import styled from 'styled-components';
import { medias, colors } from 'assets/styled/tokens';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import { Button } from 'components/Button';

import { Select } from 'components/Form/subcomponents/Select';

import selectDropdown from 'assets/icons/select-dropdown-up.svg';
export const TransparentBg = styled.div`
  background: rgba(0, 0, 0, 0.7);
  //opacity: 0.5;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 70px 0;
  z-index: 5;
  @media (min-width: ${medias.desktopSm}) {
    padding: 24px 0;
  }
`;

export const Modal = styled.div`
  background-color: #ffffff;
  //padding: 20px;
  height: ${props => props.height};
  width: 90%;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  @media (min-width: ${medias.desktopSm}) {
    width: 448px;
  }
`;
export const Header = styled.div`
  width: 100%;
  height: 56px;
  font-family: Blinker;
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: #f38a00;
  padding: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
`;
export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  //border-radius: 50%;
  border: 1px solid #e5e5e5;
  //margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    transform: scale(1);
    path {
      stroke: #bbbbbb;
      stroke-width: 2;
      fill: #bbbbbb;
    }
  }
`;
export const HeaderTitle = styled.h1`
  font-family: Blinker !important;
  font-size: 24px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: #f38a00;
  margin-left: 0;
`;
export const SignatureWarning = styled.div`
  padding: 0 12px;
  margin: 20px 0;
  width: 374px;
  border-radius: 4px;
  height: 32px;
  border: 1px solid #fad099;
  background-color: #fce3c2;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: #844b00;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const StyledFormGroup = styled(FormGroup)`
  //padding: 0 15px;
  label {
    font-family: Blinker;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: ${colors.black};
  }
`;

export const StyledFormRadio = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  //padding: 0 15px;
`;
export const Warning = styled.div`
  width: 100%;
  //padding: 0 15px;
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: ${colors.carbon};
  svg {
    margin-right: 7px;
    margin-left: 2px;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 15px;
`;
export const SaveButton = styled(Button)`
  width: 76px;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  height: 32px;
  input {
    height: 32px;
    background: ${props =>
      props.isUnitSelected ? `url(${selectDropdown}) right 10px center no-repeat` : ''} !important;
  }
  @media (min-width: ${medias.desktopSm}) {
    //width: 569px;
    height: 48px;
    input {
      height: 48px;
    }
  }
  ul {
    background-color: #fff;
    max-height: 250px;
    div > div input {
      border: none;
      /* background: ${props => (props.isUnitSelected ? `url(${selectDropdown}) right 10px center no-repeat` : '')}
        url(${selectDropdown}) right 10px center no-repeat; */
      ::placeholder {
        padding-left: 24px;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0.3px;
        font-weight: 400;
      }
    }
    div > div img {
      right: auto;
      left: 12px;
      height: 14px;
      width: 14px;
    }
    section {
      li {
        height: 32px;
        :hover {
          background-color: #f5f3f1;
          cursor: pointer;
        }
        input {
          height: 32px;
        }
        label {
          font-size: 12px;
          margin: 0;
          height: 32px;
          font-weight: 400 !important;
          font-family: Roboto;
        }
      }
    }
  }
`;
